import Rule from "../../../../common/rule";
import FootballState from "../../../../football/state/football-state";

/**
 * A downed throw-off hands the ball to the receiving team where it ended.
 *
 * This is how a league that does not return throw-offs records one: the ball
 * is dead where it lands, and the operator names the covering player - or No
 * Player / Team when nobody touched it.
 *
 * There is no shared Downed rule to reuse. Tackle football only reaches Downed
 * from a punt, where the punt's own field-change rule switches possession off
 * the Punt fragment; that rule does not apply to a kickoff, so without this
 * one a downed throw-off would leave the ball with the kicking team.
 *
 * Scoped to kickoffs for exactly that reason - on a punt the punt rule already
 * owns the change of possession, and running both would switch it twice.
 *
 * The spot needs no handling: the Downed fragment carries no field position, so
 * the ball stays where the KickOff rule put it (the kicked-to spot). The drive
 * and first down are likewise already armed by the KickOff rule.
 */
export default class KickOffDowned extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Downed &&
            play.historyContains(FootballState.KickOff)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // Resolve the receiving team from the kick itself rather than
        // switching whatever possession happens to be current: the downing
        // player is on the *kicking* team, so their teamId cannot be used,
        // and an explicit lookup keeps this independent of rule ordering.
        const kickFragment = play.getFirstFragment(FootballState.Kick);
        const kickingTeamId = kickFragment?.kickedBy?.teamId;

        if (!kickingTeamId) return [];

        gameContext.setPossessionForTeamId(
            gameContext.getOpponent(kickingTeamId)
        );

        return [];
    }
}
